var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegistrationDiscovery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.0226,
    r: 20,
    fill: "#B1DED8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2188 8.06952H15.7812C14.2279 8.06952 12.9688 9.32872 12.9688 10.882V29.1633C12.9688 30.7166 14.2279 31.9758 15.7812 31.9758H24.2188C25.7721 31.9758 27.0312 30.7166 27.0312 29.1633V10.882C27.0312 9.32872 25.7721 8.06952 24.2188 8.06952Z",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5938 10.1789H21.4062",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 10.5226C16.3881 10.5226 16.5 10.4107 16.5 10.2726C16.5 10.1346 16.3881 10.0226 16.25 10.0226C16.1119 10.0226 16 10.1346 16 10.2726C16 10.4107 16.1119 10.5226 16.25 10.5226Z",
    fill: "#150036",
    stroke: "#150036",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 29.0226C19.7761 29.0226 20 28.7988 20 28.5226C20 28.2465 19.7761 28.0226 19.5 28.0226C19.2239 28.0226 19 28.2465 19 28.5226C19 28.7988 19.2239 29.0226 19.5 29.0226Z",
    fill: "#150036",
    stroke: "#150036",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0781 20.7258L16.4844 23.5383L19.2969 18.5115L22.1094 20.7258L24.9219 16.507",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationDiscovery);
export default __webpack_public_path__ + "static/media/registration-discovery.fb17f762549d9a5a4b8ab2ca9eba4356.svg";
export { ForwardRef as ReactComponent };